<template>
    <ModalWrapper v-model="modal" :loading="reportParametersLoading" max-width="940" content-class="overflow--visible">
        <template v-slot:title>
            {{ $t(report.reportName, 2) }}
        </template>
        <template v-if="!reportParametersLoading">
            <statement-of-account-report-parameters-form
                v-model="reportParametersValid"
                :_params="reportParameters"
                @change-params="reportParameters = $event"
            />
        </template>
        <template v-if="!reportParametersLoading" v-slot:btns>
            <v-btn
                :loading="reportLoading['Excel']"
                :disabled="reportLoading['Excel'] || !reportParametersValid"
                variant="flat"
                @click="download('Excel')"
            >
                Excel
                <v-icon icon="mdi-file-excel" end />
            </v-btn>
        </template>
    </ModalWrapper>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import StatementOfAccountReportParametersForm from '@/components/account/reports/StatementOfAccountReportParametersForm.vue'
    import {clone} from '@/utils/helpers'

    @Component({
        components: {StatementOfAccountReportParametersForm},
    })
    export class StatementOfAccountReportModal extends Vue {
        modal = false
        report = {}
        reportParameters = {}
        reportParametersLoading = false
        reportParametersValid = true
        reportLoading = {
            Excel: false,
        }

        async loadReportParameters(report) {
            this.report = report
            this.reportParametersLoading = true
            this.modal = true
            this.reportParameters = {
                type: report.reportId === 'statement_of_account_clients' ? 'CLIENT' : 'SUPPLIER',
                transactionDateFrom: undefined,
                transactionDateTo: undefined,
                serviceStartDateFrom: undefined,
                serviceEndDateTo: undefined,
                transactionTypes: [],
                clientType: null,
                clientId: null,
                referenceNumber: null,
                supplierId: null,
                showZeroTransactions: false,
                fileType: 'EXCEL',
            }
            this.reportParametersLoading = false
        }

        async download(fileType) {
            this.reportLoading[fileType] = true
            try {
                await this.$api.downloadStatementOfAccount.get(
                    this.cleanEmptyParams(clone(this.reportParameters)),
                    this.$t('statement_of_account.title') + '.xlsx'
                )
            } catch (e) {
                this.$toast.error(this.$t('error_message.load_error'))
            } finally {
                this.reportLoading[fileType] = false
            }
        }

        cleanEmptyParams(obj) {
            for (let propName in obj) {
                if (obj[propName] === null || obj[propName] === undefined) {
                    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete obj[propName]
                }
            }
            return obj
        }
    }

    export default StatementOfAccountReportModal
</script>
